import { render, staticRenderFns } from "./sonRepertoryManage.vue?vue&type=template&id=2182d27c&"
import script from "./sonRepertoryManage.vue?vue&type=script&lang=js&"
export * from "./sonRepertoryManage.vue?vue&type=script&lang=js&"
import style0 from "./sonRepertoryManage.vue?vue&type=style&index=0&id=2182d27c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports